<template>

  <v-dialog v-model="dialog" width="600px">
    <v-card v-if="ready === true">
      <p class=".title ma-2">Booking   verify guest</p>
      <v-form class="mx-1" ref="vstdBknDny" v-model="vstdBknDnyValid">
      <v-container>
      When 'deny' put a 'close' restriction on the planning ?<br />
       <v-row>    
       <v-col cols="4">
          <v-select v-model="huov.huov_dag" :items="dagKeuzes" menu-props="auto" item-value="dag_nr" item-text="dag_oms" label="Close"></v-select>
       </v-col>     
       <v-col cols="4">
            <v-menu
              v-model="dat1menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="huov.huov_van_dat" 
              label="From date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="huov.huov_van_dat2" :first-day-of-week="1" @input="huov.huov_van_dat = $moment(huov.huov_van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
            </v-menu>  
          </v-col>

          <v-col cols="4">
            <v-menu
              v-model="dat2menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="huov.huov_tm_dat" 
              label="Until date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="huov.huov_tm_dat2" :first-day-of-week="1" @input="huov.huov_tm_dat = $moment(huov.huov_tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
            </v-menu>  
          </v-col>
        </v-row>
      </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary mx-2"
          small
          @click="updVstdBknDny('bkn')"
          :disabled="!vstdBknDnyValid"
          >Book</v-btn
        >
        <v-btn
          color="primary mx-2"
          small
          @click="updVstdBknDny('dny')"
          :disabled="!vstdBknDnyValid"
          >Deny</v-btn
        >
        
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
   
  </v-dialog>
 
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      vstdBknDnyValid: false,
      dagKeuzes: [],
      ready: false,
      dat1menu: false,
      dat2menu: false,
      huov: {}
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getVstdBknDny.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getVstdBknDny",
          },
          getVstdBknDny: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getVstdBknDny;
            res.data.getVstdBknDny.huov_dagKeuzes.forEach(function (dag) {
              deze.dagKeuzes.push(dag);
            });
            this.ready = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updVstdBknDny(bknDny) {
      this.$axios
        .post("ares/json/ares/huov/updVstdBknDny.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updVstdBknDny",
          },
          updVstdBknDny: {
            huov_encrid: this.huov.huov_encrid,
            huov_dag: parseInt(this.huov.huov_dag),
            huov_van_dat: this.huov.huov_van_dat,
            huov_tm_dat: this.huov.huov_tm_dat,
            huov_bkn_dny: bknDny
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updVstdBknDny.text,
              color: res.data.updVstdBknDny.color,
            });
            if (res.data.updVstdBknDny.color == "success" || res.data.updVstdBknDny.color == "warning" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.updVstdBknDny.huov_encrid); }, 1000); 
            }
            this.dialog = false;
          }
        });
    },
  }
  
};
</script>

